import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['isPaidInput', 'whenPaid']

  connect() {
    this.onChangePaidInput();
  }

  onChangePaidInput() {
    if (this.isPaidInputTarget.checked) {
      this.whenPaidTargets.forEach(($el) => $el.classList.remove('hidden'));
    } else {
      this.whenPaidTargets.forEach(($el) => $el.classList.add('hidden'));
    }
  }
}